module.exports = __webpack_public_path__ + "static/media/banner.40f28012.png";